export default __webpack_public_path__ + "static/media/hht1_ep2_minisitcom_03.92a27015.png";